import React, { useState } from 'react'
import { MuiGrid, MuiTypography } from '../../../ui/MaterialUIComponents';
import theme from '../../../../assests/theme';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import TableBody from "@material-ui/core/TableBody";
import MuiTableCell from "@material-ui/core/TableCell";

import TableRow from "@material-ui/core/TableRow";
const TableCell = withStyles({
    root: {
        border: "none"
    }
})(MuiTableCell);
const useStyles = makeStyles(theme => ({
    root: { height: 'auto' },
    rowGrid: { height: 'auto', display: 'flex' },
    rowTitleItemStyle: { fontWeight: 600 },
    rowGridItemStyle: { border: '1px solid '+theme.palette.grey.dark, textAlign: 'right', background: theme.palette.grey.lighter, width: '3%', paddingRight: 4 },
    cellGridStyle: { width: '97%' },
    emptyGridStyle: { border: '1px solid '+theme.palette.grey.dark, width: '100%', },
    cellTextStyle: { fontSize: '10px' },
}));

export default function MasterScheduleForRoom(props) {

    let roomsTimeTable = props.roomsTimeTable;
    const classes = useStyles();
    function getTableBody() {
        let rowArray = []
        if(roomsTimeTable!=undefined){
        roomsTimeTable.map(function (room, index2) {
            let cellArray = []
            let cell = <TableCell className={classes.rowGridItemStyle} width="100px" style={{ position: 'sticky', left: 0, zIndex: 98 }} colspan={1}>

                <MuiTypography variant={theme.typographyStyles.BODY2}  className={props.setTitleStyleBasedOnLicense(props.noOfRoomsTimeTableToShowIndex,index2)}>
                    {/* {room.name != undefined && room.name.toUpperCase()} */}
                    {props.showText((room.name).toUpperCase(), props.timeTableType, index2)}
                    </MuiTypography>


            </TableCell>
        
            cellArray.push(cell)
            room.days.map(function (day1, index3) {
                day1.periods.map(function (period, index1) {
                       let lastPeriod=(day1.periods.length-1==index1 && room.days.length-1!=index3)
                 
                    let cell = <TableCell style={props.getCellStyle(period.isUnavailable ? 'unavailable' : period.typeOfPeriod, day1, 'cell', ((period.subject != undefined) ? period.subject.color : 'white'), (props.noOfRoomsTimeTableToShowIndex<index2),lastPeriod)}>

                        <MuiTypography className={props.setCellStyleBasedOnLicense(props.noOfRoomsTimeTableToShowIndex,index2)} align='center'>
                            {period.typeOfPeriod == 'lunch' || period.typeOfPeriod == 'break' ? '' : (period.subject != undefined && period.subject.code != undefined) ? props.showText(period.subject.code, props.timeTableType, index2) + '-' + props.showText(period.className, props.timeTableType, index2): ''}</MuiTypography>

                    </TableCell>

                    cellArray.push(cell)
                })
            })
            let row = <TableRow>{cellArray}</TableRow>
            rowArray.push(row);
        })}
        return rowArray
    }


    return (
        <TableBody>
            {getTableBody()}
        </TableBody>


    )

}
